/**
 * @description
 * Function that cancel the editing status of the row.
 * @param {object} gridParam
 * Patameter that contains the grid object(API)
 */
const cancelRowEdit = ({ gridParam, ...props }) => {
  /** Stop editing w/o commit changed data */
  gridParam?.api?.stopEditing(true);
};

export default cancelRowEdit;
